/**
 * CashShell — layout wrapper for the /cash section.
 *
 * Wraps AppShell and feeds its `toolbar` slot a shared PageHeader (cash accent)
 * plus the shared SectionTabs sub-nav (Home / People). Pages pass their own
 * `title`/`subtitle` and optional header `actions`. All Cash Book pages use
 * this as their root.
 */
import type { ReactNode } from 'react';
import { AppShell } from '../ui/AppShell';
import { PageHeader } from '../ui/PageHeader';
import { SectionTabs } from '../ui/SectionTabs';

const CASH_TABS = [
  { label: 'Home', to: '/cash', end: true },
  { label: 'People', to: '/cash/accounts' },
] as const;

export function CashShell({
  title = 'Cash',
  subtitle,
  actions,
  back,
  children,
}: {
  title?: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
  /** Optional "← Back to X" target shown in the header (for detail pages). */
  back?: { to: string; label: string };
  children: ReactNode;
}) {
  return (
    <AppShell
      title={title}
      toolbar={
        <>
          <PageHeader
            section="cash"
            title={title}
            subtitle={subtitle}
            actions={actions}
            breadcrumb={back ? [{ label: back.label, to: back.to }] : undefined}
          />
          <SectionTabs section="cash" tabs={CASH_TABS} />
        </>
      }
    >
      {children}
    </AppShell>
  );
}
